import { Tab } from "@dmm-com/rocket-web-ui-library";
import { STAGE_SELECT_TABS } from "~/components/blocks/product/const";

export type VideoStageSeasonTabTitleProps = {
  /** 現在選択中のタブの値 */
  selectedTabValue: string;
  /** タブの切り替え処理 */
  onChangeTabValue: (v: string) => void;
  /** 配信情報タブの合計数 */
  totalDeliveryLength: number;
  /** 購入済みの合計数 */
  totalPurchasedLength: number;
};

/**
 * 複数話 | 作品末端のTabTitle部分に関するコンポーネント
 * @param props {@link VideoStageSeasonTabTitleProps}
 */
export const VideoStageSeasonTabTitle = (props: VideoStageSeasonTabTitleProps) => {
  const { selectedTabValue, onChangeTabValue, totalDeliveryLength, totalPurchasedLength } = props;

  const existDelivery = totalDeliveryLength > 0;
  const existPurchased = totalPurchasedLength > 0;

  const contents = [
    existDelivery
      ? {
          tabLabel: `配信情報`,
          value: STAGE_SELECT_TABS.DELIVERY,
        }
      : undefined,

    existPurchased
      ? {
          tabLabel: `購入済み(${totalPurchasedLength})`,
          value: STAGE_SELECT_TABS.PURCHASED,
        }
      : undefined,

    {
      tabLabel: "作品情報",
      value: STAGE_SELECT_TABS.PRODUCT_INFO,
    },

    {
      tabLabel: "レビュー",
      value: STAGE_SELECT_TABS.REVIEW,
    },
  ];

  /** `undefined`を除去した配列を生成する */
  const tabOptions = contents.flatMap((item) => {
    return item === undefined ? [] : [item];
  });

  return (
    <Tab
      name="TabBlocks"
      selectValue={selectedTabValue}
      options={tabOptions}
      onChangeTab={(targetValue) => onChangeTabValue(targetValue)}
    />
  );
};
